<template>
  <div>
    <el-dialog
        :title="fullNameTitle"
        :visible.sync="dialogVisible"
        width="1000px"
        :before-close="closeDialog"
        :close-on-click-modal="false"
    >
      <el-form
          label-width="120px"
          :model="attendanceKid.attendanceArriveKids"
          label-position="top"
          ref="attendanceKid"
      >
        <el-row :gutter="20" style="margin-top: 10px">
          <!-- Card Điểm danh đến (chỉ 1 card vì code gốc chỉ có phần đến) -->
          <el-col :span="24">
            <div class="shift-card">
              <div class="shift-header">
                <strong>Điểm danh đến</strong>
              </div>

              <div class="shift-row two-columns">
                <!-- Cột ảnh đến (có upload) -->
                <div class="shift-col shift-media">
                  <div class="shift-media-title">Ảnh đến</div>
                  <image-uploader
                      v-model="imageUrl"
                      :preview="attendanceKid.attendanceArriveKids.arriveUrlPicture"
                      placeholder="Tải ảnh đến"
                      :updateAttendance="true"
                  />
                  <div class="shift-time">
                    Giờ đến: <span>{{ attendanceKid.attendanceArriveKids.timeArriveKid | formatTime }}</span>
                  </div>
                </div>

                <!-- Cột ghi chú + thông tin -->
                <div class="shift-col shift-note">
                  <div class="shift-media-title">Nội dung ghi chú</div>
                  <el-input
                      type="textarea"
                      :rows="4"
                      placeholder="Nhập nội dung ghi chú..."
                      v-model="attendanceKid.attendanceArriveKids.arriveContent"
                  />

                  <div class="shift-status" style="margin-top: 20px" v-if="attendanceKid.attendanceArriveKids.idCreated != null">
                    <div v-if="attendanceKid.attendanceArriveKids.createdDate !== attendanceKid.attendanceArriveKids.lastModifieDate">
                      Điểm danh lần cuối: <strong>{{ attendanceKid.attendanceArriveKids.lastModifieBy }}</strong>
                      <br />
                      <span v-if="attendanceKid.attendanceArriveKids.lastModifieBy !== 'Hệ thống'">
                      Thời gian: {{ attendanceKid.attendanceArriveKids.lastModifieDate | formatDateTime }}
                      </span>
                    </div>
                    <div v-else>
                      Điểm danh: <strong>{{ attendanceKid.attendanceArriveKids.createdBy }}</strong>
                      <br />
                      <span v-if="attendanceKid.attendanceArriveKids.createdBy !== 'Hệ thống'">
                      Thời gian: {{ attendanceKid.attendanceArriveKids.createdDate | formatDateTime }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="danger" size="medium" @click="closeDialogByButton('attendanceKid')">
          <i class="el-icon-circle-close" /> Đóng
        </el-button>
        <el-button
            type="success"
            size="medium"
            :loading="loadingButton"
            @click="submitForm('attendanceKid')"
        >
          <i class="el-icon-circle-check" /> Lưu
        </el-button>
      </span>

    </el-dialog>
  </div>
</template>

<script>
import AttendanceService from "@/services/AttendanceService";

export default {
  props: {
    dialogVisible: null,
  },

  components: {
    ImageUploader: () => import("@/utils/view/ImageUploader.vue"), // điều chỉnh đường dẫn nếu cần
  },

  data() {
    return {
      attendanceKid: {
        attendanceArriveKids: {
          arriveUrlPicture: ""
        }
      },
      attendanceSave: {},
      fullNameTitle: "",
      loadingButton: false,
      imageUrl: null, // thay vì string "", dùng null để tương thích v-model File
      dialogVisibleImg: false,
      urlPictureUser: "",
    };
  },

  methods: {
    showPictureOnDevice(url) {
      if (!url) return;
      this.urlPictureUser = url;
      this.dialogVisibleImg = true;
    },

    closeDialog() {
      this.$emit("dialog-close", false);
      // Không cần clearFiles vì không dùng el-upload nữa
      this.handleRemove();
      setTimeout(() => {
        if (this.$refs["attendanceKid"]) {
          this.$refs["attendanceKid"].resetFields();
        }
      }, 300);
    },

    closeDialogByButton() {
      this.closeDialog();
    },

    handleRemove() {
      this.imageUrl = null;
    },

    submitForm(formRef) {
      this.$refs[formRef].validate((valid) => {
        if (!valid) {
          console.log("error validate data!");
          return false;
        }

        let formData = new FormData();
        const inputData = this.attendanceKid.attendanceArriveKids;

        // Append tất cả các field
        for (const key in inputData) {
          if (inputData[key] !== null && inputData[key] !== undefined) {
            formData.append(key, inputData[key]);
          }
        }

        // Append file nếu có
        if (this.imageUrl instanceof File) {
          formData.append("multipartFile", this.imageUrl);
        }

        this.loadingButton = true;

        AttendanceService.updateArriveContent(
            this.attendanceKid.attendanceArriveKids.id,
            formData
        )
            .then(() => {
              this.$message({
                message: "Lưu điểm danh đến thành công",
                type: "success",
              });
              setTimeout(() => {
                this.closeDialogByButton();
              }, 500);
            })
            .catch((err) => {
              console.log(err);
              this.$message({
                message: "Lưu điểm danh đến thất bại",
                type: "error",
              });
            })
            .finally(() => {
              setTimeout(() => {
                this.loadingButton = false;
              }, 500);
            });
      });
    },

    getDataArriveRowInitial(row) {
      this.attendanceKid = row;
      this.fullNameTitle = "Thông tin điểm danh đến: " + (row.kids?.fullName || "");
    },
  },
};
</script>

<style scoped>
/* CARD & LAYOUT */
.shift-card {
  padding: 20px;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #e0e7ff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  margin-bottom: 24px;
}

.shift-header {
  font-size: 18px;
  font-weight: 600;
  color: #1e40af;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e5efff;
}

.shift-row {
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  align-items: flex-start;
}

.shift-col.shift-media {
  flex: 0 0 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.shift-media-title {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 10px;
  width: 100%;
}

.shift-time {
  margin-top: 10px;
  font-size: 14px;
  color: #3b82f6;
  font-weight: 500;
  width: 100%;
  text-align: center;
}

.shift-col.shift-note {
  flex: 1;
  min-width: 300px;
}

.shift-row.two-columns {
  justify-content: center;
  gap: 80px;
  padding: 0 40px;
}

.shift-status {
  margin-top: 20px;
  font-size: 13.5px;
  line-height: 1.7;
  color: #4b5563;
}

.shift-status strong {
  color: #1e40af;
}

/* DIALOG STYLE */
::v-deep .el-dialog {
  border-radius: 12px;
  overflow: hidden;
}

::v-deep .el-dialog__header {
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  padding: 18px 24px !important;
}

::v-deep .el-dialog__title {
  color: white !important;
  font-size: 22px !important;
  font-weight: 600;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: white !important;
  font-size: 24px;
}

::v-deep .el-dialog__body {
  max-height: 70vh;
  overflow-y: auto;
  background: #f8fafc;
  padding: 20px 24px !important;
}

::v-deep .el-dialog__footer {
  background: #f1f5f9;
  padding: 16px 24px !important;
  border-top: 1px solid #e2e8f0;
  text-align: right;
}

::v-deep .el-button--success {
  background: #10b981;
  border-color: #10b981;
}

::v-deep .el-button--success:hover {
  background: #059669;
  border-color: #059669;
}

::v-deep .el-button--danger {
  background: #ef4444;
  border-color: #ef4444;
}

::v-deep .el-button--danger:hover {
  background: #dc2626;
  border-color: #dc2626;
}

.el-divider {
  margin: 20px 0;
  background: #e2e8f0;
}

/* Responsive */
@media (max-width: 768px) {
  .shift-row.two-columns {
    flex-direction: column;
    align-items: center;
    gap: 40px;
    padding: 0 20px;
  }
  .shift-col.shift-media {
    width: 100%;
    max-width: 220px;
  }
}
</style>